import {ActivatedRouteSnapshot, CanActivateFn, RedirectCommand, Router, UrlTree} from '@angular/router';
import {inject} from "@angular/core";
import {map} from "rxjs";
import {AuthService} from "../services/auth.service";
import RelationContact from "../model/relation-contact.model";
import Survey from "../model/survey.model";

export const relationContactCanViewSelectedSurveyGuard: CanActivateFn = (route: ActivatedRouteSnapshot) => {
  const authService: AuthService = inject(AuthService);
  const router: Router = inject(Router);

  /**
   * @description check if the currently active relation can view the selected survey
   * @file packages/hgvt/mijnomgeving/src/UI/src/config.ts - Configuration file for the application
   * @file packages/hgvt/mijnomgeving/src/UI/src/mijntrined.prod.config.ts - Production configuration file for the application
   */
  return authService.getUser(['surveys']).pipe(
    map((relationContact: RelationContact | null) => {
      if (!relationContact?.surveys) {
        return false; // No surveys found just stop
      }
      const routeSurveyId: number = parseInt(route.params['id']);
      const foundSurvey: Survey | null = relationContact?.surveys.find((survey: Survey) => survey.id === routeSurveyId) ?? null;

      if (foundSurvey === null) {
        const path : UrlTree = router.parseUrl("/dashboard");
        return new RedirectCommand(path);
      }
      return true;
    })
  );
}
